import { Navigate, useLocation } from 'react-router-dom'

export const ProfileSettingsIntegrationRedirect: React.FC = () => {
  const location = useLocation()

  return <Navigate to={`/account/integration-settings${location.search}`} replace />
}
